export default "__VITE_ASSET__cvUhBjVL__"